import TimePicker from '@alifd/next/lib/time-picker';
export default TimePicker;